import {
  QualityStatusTypes,
  Candidate,
  OpenToWorkTypes,
} from '$types/candidates.d';
import { useTranslation } from 'react-i18next';
import {
  useUpdateCandidateOpenToWorkMutation,
  useUpdateCandidateQualityStatusMutation,
} from '$store/modules/candidates';
import CandidateModifyStatus from '../CandidateCard/CandidateModifyStatus/CandidateModifyStatus';

const ScoresTabContainer = ({ candidate }: { candidate: Candidate }) => {
  const [t] = useTranslation('global');

  const [updateCandidateQuality] = useUpdateCandidateQualityStatusMutation();

  const saveQualityStatus = async (newValue: string) => {
    await updateCandidateQuality({
      QualityStatus: newValue as QualityStatusTypes,
      CandidateId: candidate?.Id as number,
    });
  };

  const getQualityStatusColor = (value: string) => {
    switch (value) {
      case QualityStatusTypes['5-Star']:
      case QualityStatusTypes.Good:
        return 'bg-internal-main';
      case QualityStatusTypes.Farm:
        return 'bg-blue-500';
      case QualityStatusTypes.Bad:
        return 'bg-red-400';
      default:
        return 'bg-gray-400';
    }
  };

  const [updateCandidateOpenToWork] = useUpdateCandidateOpenToWorkMutation();

  const saveOpenToWork = async (newValue: string) => {
    await updateCandidateOpenToWork({
      OpenToWork: newValue as OpenToWorkTypes,
      CandidateId: candidate?.Id as number,
    });
  };

  const getOpenToWorkColor = (value: string) => {
    switch (value) {
      case OpenToWorkTypes.Active:
      case OpenToWorkTypes.Interested:
        return 'bg-internal-main';
      case OpenToWorkTypes['Not Available']:
        return 'bg-red-400';
      default:
        return 'bg-gray-400';
    }
  };

  return (
    <section className="grid grid-cols-2 lg:grid-cols-4 gap-8 bg-white p-8 rounded">
      <CandidateModifyStatus
        title={t('SearchCandidates.Table.QualityStatus')}
        id="qualityStatus"
        onSave={saveQualityStatus}
        value={candidate?.QualityStatus}
        options={(
          Object.keys(QualityStatusTypes) as Array<
            keyof typeof QualityStatusTypes
          >
        ).reduce((prev, act) => {
          const tempData = {
            value: act,
            text: QualityStatusTypes[act] as string,
            style: getQualityStatusColor(QualityStatusTypes[act]),
          };
          prev.push(tempData);
          return prev;
        }, [] as { text: string; value: string; style: string }[])}
      />
      <CandidateModifyStatus
        title={t('SearchCandidates.Table.OpenToWork')}
        id="openToWork"
        onSave={saveOpenToWork}
        value={candidate?.OpenToWork}
        options={(
          Object.keys(OpenToWorkTypes) as Array<keyof typeof OpenToWorkTypes>
        ).reduce((prev, act) => {
          const tempData = {
            value: act,
            text: OpenToWorkTypes[act] as string,
            style: getOpenToWorkColor(OpenToWorkTypes[act]),
          };
          prev.push(tempData);
          return prev;
        }, [] as { text: string; value: string; style: string }[])}
      />
    </section>
  );
};

export default ScoresTabContainer;
